<template>
  <div>
    <template v-if="visibleButtons.length === 1">
      <v-btn
        v-status="visibleButtons[0].status"
        :class="getButtonClass(visibleButtons[0])"
        :title="visibleButtons[0].label"
        fab
        small
        elevation="0"
        @click.stop="visibleButtons[0].action(data, visibleButtons[0].name)"
      >
        <v-icon v-if="visibleButtons[0].name === 'status' && data.disabled === 1" small>mdi-account-cancel</v-icon>
        <v-icon v-else-if="visibleButtons[0].name === 'status' && data.disabled === 0" small>mdi-account-check</v-icon>
        <v-icon class="pa-0" v-else small>mdi-{{ visibleButtons[0].icon }}</v-icon>
      </v-btn>
    </template>

    <v-speed-dial v-else-if="visibleButtons.length > 1" v-model="fab" direction="right">
      <template v-slot:activator>
        <v-btn v-model="fab" fab icon :title="$t('actions')" x-small>
          <v-icon v-if="fab" color="pink darken-1">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-btn
        v-for="(item, index) in visibleButtons"
        :key="index"
        v-status="item.status"
        :class="getButtonClass(item)"
        :title="item.label"
        fab
        small
        @click.stop="item.action(data, item.name)"
      >
        <v-icon v-if="item.name === 'status' && data.disabled === 1" small>mdi-account-cancel</v-icon>
        <v-icon v-else-if="item.name === 'status' && data.disabled === 0" small>mdi-account-check</v-icon>
        <v-icon class="pa-0" v-else small>mdi-{{ item.icon }}</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  name: "ordersListButton",

  props: {
    data: Object,
    action: Function,
    meta: Object,
  },

  data() {
    return {
      fab: false,
    };
  },
  
  computed: {
    visibleButtons() {
      if (!this.meta || !this.meta.buttons) return [];
      return this.meta.buttons.filter(item => this.checkCondition(item));
    }
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    checkCondition(item) {
      if (!!item?.conditions) {
        if (typeof item.conditions === "string") {
          return eval(`${item.conditions}`);
        }
        return true;
      } else return true;
    },
    
    getButtonClass(item) {
      if (item.name === 'status' && this.data.disabled === 0) {
        return 'btn btn-outline-danger';
      }
      if (item.name === 'status' && this.data.disabled === 1) {
        return 'btn btn-outline-success';
      }
      return `btn ${item.class || ''}`;
    }
  },
};
</script>

<style scoped></style>
